import { ReprintType } from "../../types";
import { PosApiRequest } from "../pos-api-request";

export class ReprintReceiptRequest extends PosApiRequest {
  public ReprintType: ReprintType;
  public OriginalTxnRef: string;
}
